function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, eventData, isHeaderMenuOpen, isMenuOpen, openModal, renderCustomEventModal, searchFilter, selected) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['block-selector'] = function(isMenuOpen) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const selectorIcon = $helpers.selectedIcon() || $attr(`selector-icon`);;
        __jade_nodes = __jade_nodes.concat((selectorType === `button`) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "key": JSON.stringify($attr(`selected`)) + $helpers.labelText(selectedLabel),
            "attrs": {
              disabled: $attr(`disabled`),
              icon: selectorIcon,
              size: `small`,
              theme: selectorTheme,
              pressed: isMenuOpen,
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`prefix-label`));
            __jade_nodes = __jade_nodes.concat($helpers.labelText(selectedLabel));
            __jade_nodes = __jade_nodes.concat(block && block());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = []; /*  block label */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              disabled: $attr(`disabled`)
            }, {
              'mp-query-menu-label': true
            }),
          }, (function() {
            var __jade_nodes = []; /*  selector icon */
            __jade_nodes = __jade_nodes.concat((selectorIcon) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-menu-label-icon': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": {
                    icon: selectorIcon
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined); /*  selector label */
            __jade_nodes = __jade_nodes.concat(($helpers.showInput() && $helpers.showMultiPartLabel()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (selectedLabel);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, labelPart, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          [`mp-query-label-part-${labelPart.type}`]: true
                        }, {
                          'mp-query-label-part': true
                        }),
                      }, [__vjadeSafeCode(labelPart.label)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var labelPart = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              [`mp-query-label-part-${labelPart.type}`]: true
                            }, {
                              'mp-query-label-part': true
                            }),
                          }, [__vjadeSafeCode(labelPart.label)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($helpers.labelText(selectedLabel));;
              return __jade_nodes
            }).call(this)));
            __jade_nodes = __jade_nodes.concat(block && block());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const isCustomEventSelected = selected && selected.custom;;
    const customEvents = eventData && eventData.filter(event => !!event.id);;
    const canWriteCustomEvents = $helpers.canWriteCustomEvents();;
    const canWriteCustomProperties = $helpers.canWriteCustomProperties();;
    const selectorType = $attr(`selector-type`);;
    const selectorTheme = $helpers.getSelectorTheme();;
    const selectedLabel = $helpers.showInput() ? $helpers.selectedLabel() || $attr(`label`) : $attr(`label`);;
    const prefixLabel = $attr(`prefix-label`) || $helpers.getPrefixLabel();;
    const headerSegments = $helpers.getHeaderSegments();;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'has-prefix-label': prefixLabel,
          [`mp-query-theme-${selectorTheme}`]: true,
        }, {
          'mp-query-block': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-block-header-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (headerSegments);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((((segment.type) == (`text`))) ?
                    ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-block-header-segment-label': true
                        },
                      }, [__vjadeSafeCode(segment.value)]));;
                      return __jade_nodes
                    }).call(this)) :
                    (((segment.type) == (`select`))) ?
                    ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-block-header-drop-menu': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                          "attrs": {
                            open: isHeaderMenuOpen
                          },
                          "on": {
                            change: $helpers.handleHeaderMenuVisibilityChange
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                            "attrs": {
                              sections: JSON.stringify($helpers.getHeaderMenuSection(segment))
                            },
                            "on": {
                              clickItem: $helpers.handleHeaderSelectionChanged
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: $helpers.handleHeaderSelectClicked
                        },
                        "class": {
                          'mp-query-block-header-segment-selector-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(segment.selectedItem.label);
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": {
                            icon: 'caret-down'
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) :
                    undefined);;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var $index = $$objKey;
                  if ($$obj.hasOwnProperty($index)) {
                    $$iterated = true;
                    var segment = $$obj[$index];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((((segment.type) == (`text`))) ?
                        ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-query-block-header-segment-label': true
                            },
                          }, [__vjadeSafeCode(segment.value)]));;
                          return __jade_nodes
                        }).call(this)) :
                        (((segment.type) == (`select`))) ?
                        ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-query-block-header-drop-menu': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                              "attrs": {
                                open: isHeaderMenuOpen
                              },
                              "on": {
                                change: $helpers.handleHeaderMenuVisibilityChange
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                                "attrs": {
                                  sections: JSON.stringify($helpers.getHeaderMenuSection(segment))
                                },
                                "on": {
                                  clickItem: $helpers.handleHeaderSelectionChanged
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: $helpers.handleHeaderSelectClicked
                            },
                            "class": {
                              'mp-query-block-header-segment-selector-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(segment.selectedItem.label);
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: 'caret-down'
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) :
                        undefined);;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })()); /*  information label */
          __jade_nodes = __jade_nodes.concat(($attr(`help-text`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'header-info': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `info`
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "class": {
                  'help-text': true
                },
              }, [__vjadeSafeCode($attr(`help-text`))]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  .mp-query-block-unit */
        __jade_nodes = __jade_nodes.concat((selectorType !== `button` && prefixLabel) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-block-unit': true,
              'mp-query-block-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(prefixLabel);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: $helpers.handleLabelClick
          },
          "class": Object.assign({}, {
            'mp-query-editing': $helpers.showInput() && isMenuOpen
          }, {
            'mp-query-block-selector': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['block-selector'].call({
            block: function() {
              return (function() {
                var __jade_nodes = []; /*  custom event editing */
                __jade_nodes = __jade_nodes.concat(($helpers.showInput() && isCustomEventSelected) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((canWriteCustomEvents && $helpers.isEditableCustomEvent()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "on": {
                        click: $helpers.clickEditCustomEvent
                      },
                      "class": {
                        'mp-query-block-edit-custom-event-icon': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": {
                          icon: `compose`
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this)) : undefined); /*  remove button */
                __jade_nodes = __jade_nodes.concat(($attr(`removable`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "on": {
                      click: $helpers.handleRemove
                    },
                    "class": {
                      'mp-query-block-remove-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": {
                        icon: `circle-clear`
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this);
            }
          }, isMenuOpen));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              [`is-${$attr(`dropdown-alignment`)}-aligned`]: true
            }, {
              'mp-query-drop-menu-container': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.isReady()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                "attrs": {
                  open: isMenuOpen,
                  'prevent-close-selectors': JSON.stringify($helpers.preventCloseSelectors()),
                },
                "on": {
                  change: $helpers.handleMenuChange,
                  click: ev => ev.stopPropagation(),
                  /* clicks in the drop menu should not bubble up */
                },
              }, (function() {
                var __jade_nodes = [];
                const childAttrs = {
                  attrs: $helpers.getChildMenuAttributes(),
                  on: {
                    select: $helpers.handleSelect,
                    deletecustomproperty: $helpers.handleDeleteCustomProperty,
                    tooltipContextAction: $helpers.handleTooltipContextAction,
                  },
                  hook: {
                    insert: $helpers.menuInserted
                  },
                  props: {
                    tooltipPositionParentElement: $helpers.getTooltipPositionParentElement(),
                  },
                };; /*  search filter */
                __jade_nodes = __jade_nodes.concat($helpers.isContentSearchable() ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'search-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                      "attrs": {
                        'icon': 'search',
                        'placeholder': 'Search',
                        'value': searchFilter,
                      },
                      "on": {
                        input: $helpers.handleSearchInput
                      },
                      "hook": {
                        insert: $helpers.searchInputInserted
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined); /*  selection menu */
                __jade_nodes = __jade_nodes.concat($component.child($helpers.getChildMenuName(), childAttrs));
                __jade_nodes = __jade_nodes.concat(($helpers.showCreateCustomEvent()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                    "on": {
                      click: $helpers.handleCreateCustomEvent
                    },
                    "class": {
                      'mp-button-bar-secondary': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Create custom event");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  TODO: refactor mp-custom-event-modal to live inside mp-events-menu */
        /*  There are separate flags `renderCustomEventModal` and `openModal`. When the modal is closed (e.g. after saving, */
        /*  clicking the cancel button), `openModal` is set to null. But we keep rendering the modal while it animates */
        /*  out, at which point the `modalClosed` event fires, and `renderCustomEventModal` is set to false to stop rendering the */
        /*  modal. */
        __jade_nodes = __jade_nodes.concat((renderCustomEventModal && canWriteCustomEvents && eventData.length) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-custom-event-modal", {
            "attrs": $helpers.filterAttributes({
              'all-data-groups': $attr(`all-data-groups`),
              'events': JSON.stringify(eventData),
              'is-blocked-people': $attr(`is-blocked-people`),
              'open': openModal === $helpers.MODAL_TYPE.CustomEvent,
              'project-has-people': $attr(`project-has-people`),
              'project-id': $attr(`project-id`),
              'selected-custom-event-id': $helpers.getSelectedCustomEventId(),
              'workspace-id': $attr(`workspace-id`),
            }),
            "on": {
              cancelEditingCustomEvent: $helpers.cancelEditingCustomEventModal,
              deletedCustomEvent: $helpers.deletedCustomEvent,
              modalClosed: $helpers.closeCustomEventModal,
              savedCustomEvent: $helpers.savedCustomEvent,
              track: $helpers.captureTracking,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "eventData" in locals ? locals.eventData : typeof eventData !== "undefined" ? eventData : undefined, "isHeaderMenuOpen" in locals ? locals.isHeaderMenuOpen : typeof isHeaderMenuOpen !== "undefined" ? isHeaderMenuOpen : undefined, "isMenuOpen" in locals ? locals.isMenuOpen : typeof isMenuOpen !== "undefined" ? isMenuOpen : undefined, "openModal" in locals ? locals.openModal : typeof openModal !== "undefined" ? openModal : undefined, "renderCustomEventModal" in locals ? locals.renderCustomEventModal : typeof renderCustomEventModal !== "undefined" ? renderCustomEventModal : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "selected" in locals ? locals.selected : typeof selected !== "undefined" ? selected : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;